"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
// Used in TrackRecordView, defined in EkoAnalytics - it's the object provided when EkoAnalytics fires a 'track' event
var trackRecord = _propTypes["default"].shape({
  timestamp: _propTypes["default"].number,
  event: _propTypes["default"].string,
  args: _propTypes["default"].array,
  snowplowContexts: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    schema: _propTypes["default"].string,
    data: _propTypes["default"].object
  }))
});
var _default = exports["default"] = {
  trackRecord: trackRecord
};